import { authenticationStore, AuthenticationStore } from './AuthenticationStore';
import { reaction, runInAction, makeAutoObservable } from 'mobx';
import { AthleteCoachSubscription, AthleteCoachSubscriptionApi } from '../Model/CoachSubscription/AthleteCoachSubscription';

function createCoachSubscriptionStore(authentication: AuthenticationStore) {
  const store = makeAutoObservable({
    authentication,
    current: undefined as AthleteCoachSubscription | undefined,

    fetchSubscription(): Promise<AthleteCoachSubscription> {
      return AthleteCoachSubscriptionApi.current().then((subscription) => {
        runInAction(() => (this.current = subscription));
        return subscription;
      });
    },

    get canShowAllContent(): boolean {
      return this.current?.plan === 'standard' || this.current?.plan === 'engagement';
    },

    get canShowAcademy(): boolean {
      return this.current?.plan === 'academy' || this.current?.plan === 'standard' || this.current?.plan === 'engagement';
    },

    get canShowMove(): boolean {
      return this.current?.plan === 'move' || this.current?.plan === 'standard' || this.current?.plan === 'engagement';
    },

    get onlyMove(): boolean {
      return this.current?.plan === 'move';
    },

    get onlyAcademy(): boolean {
      return this.current?.plan === 'academy';
    },
  });

  reaction(
    () => authentication.athleteId,
    (athleteId) => {
      if (!athleteId) {
        runInAction(() => (store.current = undefined));
      }
    },
  );

  return store;
}

export const coachSubscriptionStore = createCoachSubscriptionStore(authenticationStore);
export type CoachSubscriptionStore = ReturnType<typeof createCoachSubscriptionStore>;
